export default "__VITE_PUBLIC_ASSET__1ba6b914__"